import { __assign, __rest } from "tslib";
// DS6.7
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Tag.scss';
/**
 * A tag for use with our `<InputField />` and related components.
 *
 * This will render a `<span>` or `<PlainButtonOrLink />` depending on if `onClick` is passed.
 */
var Tag = function (_a) {
    var children = _a.children, size = _a.size, postfix = _a.postfix, className = _a.className, href = _a.href, isSelected = _a.isSelected, disabled = _a.disabled, isTruncated = _a.isTruncated, onClick = _a.onClick, rest = __rest(_a, ["children", "size", "postfix", "className", "href", "isSelected", "disabled", "isTruncated", "onClick"]);
    var ElementTag = onClick || href ? PlainButtonOrLink : 'span';
    return (React.createElement(ElementTag, __assign({ className: c(s['root'], disabled && s['disabled'], s[size], isSelected && s['selected'], isTruncated && s['truncated'], className), href: href, onClick: onClick }, rest),
        isTruncated ? (React.createElement("span", { className: s['truncated-contents'] }, children)) : (children),
        postfix && React.createElement("span", { className: s['postfix'] }, postfix)));
};
Tag.displayName = 'Tag';
export default Tag;
//# sourceMappingURL=Tag.js.map